// extracted by mini-css-extract-plugin
module.exports = {"MyOrders":"style_MyOrders__1y12j"};